
import React, { useState, useEffect, useContext } from "react";
import { plantCurveApi } from "../../../../../../../../api/Api";
import EnergyChartPower from "../../../../../../../../components/charts/energy_reporting/EnergyChartPower";
import { AppThemeContext } from "../../../../../../../../context/AppThemeContext";
import { useTheme } from "@emotion/react";
import AppModal from "../../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../../components/inverter/InvverterFullSize";

// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export default function PlantEnergyKusumData() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const { palette } = useTheme();
    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const now = new Date(); // Current date and time

    // Default start and end dates
    const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0); // 5:00 AM
    const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0); // 8:00 PM

    const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
    const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [chartLabels, setChartLabels] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [gradientFill, setGradientFill] = useState(null);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
        LOC_CODE: sessionStorage.getItem("LCODE") || "",
        DT1: startDate,
        DT2: endDate,
        WEB_KEY: "WEBXYZ321",
    };

    // Fetch log data from the API
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await plantCurveApi(credentials);

            if (res?.data && Array.isArray(res.data)) {
                const labels = res.data.map((item) => item.datet);

                // const datasets = [
                //     {
                //         label: "Generation (kW)",
                //         data: res.data.map((item) => parseFloat(item.TOT_INV_KW) || 0),
                //         borderColor: "red",
                //         backgroundColor: gradientFill,
                //         tension: 0.3,
                //         fill: true,
                //         borderWidth: 2,
                //         pointRadius: 0.9,
                //         pointHoverRadius: 1,
                //     },
                //     {
                //         label: "Energy Export (kW)",
                //         data: res.data.map((item) => parseFloat(item.NET_METER_KW) || 0),
                //         borderColor: "#5CA904",
                //         backgroundColor: gradientFill,
                //         tension: 0.3,
                //         fill: true,
                //         borderWidth: 2,
                //         pointRadius: 0.9,
                //         pointHoverRadius: 1,
                //     },
                // ];

                const datasets = [
                    {
                        label: "Generation (kW)",
                        data: res.data.map((item) => {
                            const value = item.TOT_INV_KW;
                            return value === "" || value === null ? null : parseFloat(value);
                        }),
                        borderColor: "red",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                    },
                    {
                        label: "Energy Export (kW)",
                        data: res.data.map((item) => {
                            const value = item.NET_METER_KW;
                            return value === "" || value === null ? null : parseFloat(value);
                        }),
                        borderColor: "#5CA904",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                    },
                ];

                setChartLabels(labels);
                setChartData(datasets);
            } else {
                console.warn("Empty or Invalid API Response Data");
                setChartLabels([]);
                setChartData([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const createGradientShade = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, palette.primary.main);
        gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
        return gradient;
    };

    useEffect(() => {
        setGradientFill(createGradientShade());
    }, [palette.primary.main]);

    // Fetch data on component mount and set up 30-second interval
    useEffect(() => {
        fetchLogData(); // Fetch data initially

        // Set up interval for 30-second refresh
        const interval = setInterval(() => {
            fetchLogData();
        }, 300000); // 30 seconds

        // Clean up interval on component unmount
        return () => clearInterval(interval);
    }, [startDate, endDate, gradientFill]);

    const handleStartDateChange = (value) => {
        const formattedDate = formatDateTime(new Date(value));
        setStartDate(formattedDate);
    };

    const handleEndDateChange = (value) => {
        const formattedDate = formatDateTime(new Date(value));
        setEndDate(formattedDate);
    };

    return (

        <>
            <div className="row" style={{ height: "21.4rem" }}>

                <div className="col-md-12">

                    <div style={{
                        marginBottom: "5px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "16px",
                    }}>
                        {/* Left-side title */}
                        <div style={{ marginLeft: "7px", fontSize: "10px", color: "black" }}>
                            Plant [kW]
                        </div>

                        {/* Right-side date pickers */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "4px", color: "black" }}>
                                <span>From:</span>
                                <input
                                    type="datetime-local"
                                    value={startDate.replace(" ", "T")}
                                    onChange={(e) => handleStartDateChange(e.target.value)}
                                    style={{
                                        padding: "2px 8px",
                                        borderRadius: "14px",
                                        border: "1px solid #ccc",
                                        color: "black"
                                    }}
                                />
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "4px", color: "black" }}>
                                <span>To:</span>
                                <input
                                    type="datetime-local"
                                    value={endDate.replace(" ", "T")}
                                    onChange={(e) => handleEndDateChange(e.target.value)}
                                    style={{
                                        padding: "2px 8px",
                                        borderRadius: "14px",
                                        border: "1px solid #ccc",
                                        color: "black"
                                    }}
                                />
                            </label>
                        </div>
                    </div>



                    <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
                </div>

            </div>

        </>


    );
}


// 2.
// import EnergyChartPower from "../../../../../../../../components/charts/energy_reporting/EnergyChartPower";

// export default function PlantEnergyKusumData() {

//     // ✅ Static 5 labels (time)
//    const chartLabels = [
//     "05:00",
//     "06:00",
//     "07:00",
//     "08:00",
//     "09:00",
//     "10:00",
//     "11:00",
//     "12:00",
//     "13:00"
// ];

//     // ✅ Static blank datasets
//    const chartData = [
//     {
//         label: "Generation (kW)",
//         data: [1,2,3,"",5,"","",8,9],
//         borderColor: "red",
//         tension: 0.3,
//         fill: true,
//     },
//     {
//         label: "Energy Export (kW)",
//         data: [1,2,3,4,5,6,7,8,9],
//         borderColor: "#5CA904",
//         tension: 0.3,
//         fill: true,
//     },
// ];

//     return (
//         <>
//             <div className="row" style={{ height: "21.4rem" }}>
//                 <div className="col-md-12">

//                     {/* Header */}
//                     <div style={{
//                         marginBottom: "5px",
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center"
//                     }}>
//                         <div style={{ fontSize: "10px", color: "black" }}>
//                             Plant [kW]
//                         </div>
//                     </div>

//                     {/* ✅ Static Chart */}
//                     <EnergyChartPower
//                         labels={chartLabels}
//                         data={chartData}
//                         title={""}
//                     />

//                 </div>
//             </div>
//         </>
//     );
// }